module.exports = "/_next/static/images/offers5-2x-6419cfe7d5b34e7d7fa72e577d540995.jpg.webp";